import { apiSlice } from "../../app/api/apiSlice";

export const ViewWorkbbookAPISlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    likeDislike: builder.mutation({
      query: (request) => ({
        url: "/workbookapi/count",
        method: "POST",
        body: request,
      }),
    }),
  }),
});

export const { useLikeDislikeMutation } = ViewWorkbbookAPISlice;
